import { FooterSEOContent } from "@faire/deprecated-retailer-visitor-shared/components/Footer/FooterSEOContent";
import { useGetStoreType } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetStoreType";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { getSettingOpenWithFaireAvailableForCountry } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingOpenWithFaireAvailableForCountry";
import { useSettingOwFGrant } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingOwFGrant";
import { useUserStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useUserStore";
import { ApplicationStatus } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/ApplicationStatus/index";
import { FooterCard } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/FooterCard/FooterCard";
import { FrequentlyAskedQuestions } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/FrequentlyAskedQuestions";
import { GetTheInventoryYouNeed } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/GetTheInventoryYouNeed";
import { HeaderCardFaireAcademy } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/HeaderCard/HeaderCardFaireAcademy";
import { HeaderCardPartialRetailers } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/HeaderCard/HeaderCardPartialRetailers";
import { MissionStatement } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/MissionStatement";
import { OpenUpShopWithConfidence } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/OpenUpShopWithConfidence/index";
import { OwfGrantUpsell } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/OwfGrantUpsell";
import { UpsellStats } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/UpsellStats";
import { OpenWithFaireHelmet } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireHelmet";
import { OpenWithFaireTestimonial } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireTestimonial";
import { LoadingWrapper } from "@faire/deprecated-retailer-visitor-shared/views/owf-small-business-grant/landing-page/styles";
import { useGetGrantDates } from "@faire/deprecated-retailer-visitor-shared/views/owf-small-business-grant/useGetGrantDates";
import { LoadingSpinner } from "@faire/slate/components/loading-spinner";
import { useQuery as useGetGrantApplicationInfo } from "@faire/web-api--source/endpoints/www/api/small-business-grant/application/get-hooks";
import netTerms from "@faire/web-api--source/routes/www/net-terms";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { Column } from "@faire/web/slate/Layout";
import React from "react";
import { Redirect } from "react-router-dom";

export const OpenWithFaireFaireAcademyLandingPage: React.FC = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const isOwfGrant = useSettingOwFGrant();
  const { isOwnerUser } = useUserStore();
  const { hasActiveCycle } = useGetGrantDates();
  const { shouldShowPartialRetailersBasedOnStoreType } = useGetStoreType();
  const { data: grantApplicationInfo, isLoading } =
    useGetGrantApplicationInfo();

  const hasSubmitted = isNotUndefined(
    grantApplicationInfo?.application?.submitted_at
  );

  const shouldShowOwfGrantUpsell =
    isOwfGrant &&
    hasActiveCycle &&
    (!isLoggedInRetailer ||
      (isLoggedInRetailer && isOwnerUser && !hasSubmitted));

  if (isLoading) {
    return (
      <LoadingWrapper>
        <LoadingSpinner size="xLarge" />
      </LoadingWrapper>
    );
  }

  if (!getSettingOpenWithFaireAvailableForCountry()) {
    return <Redirect to={netTerms()} />;
  }

  return (
    <>
      <OpenWithFaireHelmet />
      <Column align="center">
        {shouldShowPartialRetailersBasedOnStoreType ? (
          <HeaderCardPartialRetailers />
        ) : (
          <HeaderCardFaireAcademy />
        )}
        <ApplicationStatus />
        <MissionStatement />
        <GetTheInventoryYouNeed />
        {shouldShowOwfGrantUpsell ? <OwfGrantUpsell /> : null}
        <OpenUpShopWithConfidence />
        <UpsellStats />
        <OpenWithFaireTestimonial />
        <FrequentlyAskedQuestions />
        <FooterCard />
      </Column>
      <FooterSEOContent />
    </>
  );
};
